// extracted by mini-css-extract-plugin
export default {"btnSubmit":"CustomTagItem_btnSubmit__6IMb+","up":"CustomTagItem_up__sXHnW","blockHead":"CustomTagItem_blockHead__P3WTM","btnReset":"CustomTagItem_btnReset__3J7Y5"};